var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProvideIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9997 3.33398H14.9997C14.0792 3.33398 13.333 4.08018 13.333 5.00065V8.33398C13.333 9.25446 14.0792 10.0007 14.9997 10.0007H24.9997C25.9201 10.0007 26.6663 9.25446 26.6663 8.33398V5.00065C26.6663 4.08018 25.9201 3.33398 24.9997 3.33398Z",
    stroke: "#0094FB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 6.66602H30.0003C30.8844 6.66602 31.7322 7.0172 32.3573 7.64233C32.9825 8.26745 33.3337 9.11529 33.3337 9.99935V33.3327C33.3337 34.2167 32.9825 35.0646 32.3573 35.6897C31.7322 36.3148 30.8844 36.666 30.0003 36.666H10.0003C9.11627 36.666 8.26842 36.3148 7.6433 35.6897C7.01818 35.0646 6.66699 34.2167 6.66699 33.3327V9.99935C6.66699 9.11529 7.01818 8.26745 7.6433 7.64233C8.26842 7.0172 9.11627 6.66602 10.0003 6.66602H13.3337",
    stroke: "#0094FB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.334H26.6667",
    stroke: "#0094FB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26.666H26.6667",
    stroke: "#0094FB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 18.334H13.3505",
    stroke: "#0094FB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 26.666H13.3505",
    stroke: "#0094FB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvideIcon);
export default __webpack_public_path__ + "static/media/ProvideIcon.96632ae196096ef7e253565c0a30f35b.svg";
export { ForwardRef as ReactComponent };